/*
 * @Date: 2020-03-31 16:11:15
 * @LastEditors: Travin
 * @LastEditTime: 2020-06-05 15:42:10
 */ 
import OrderReport from "@/pages/report/order-report"
import ImportRecords from "@/pages/report/import-records"
import ReplaceReport from '@/pages/report/replace-report'
import OwnerRevenue from '@/pages/report/owner-revenue'
import PmsCheckRepor from '@/pages/report/pms-check-repors'
import MiniReport from '@/pages/report/mini-report'
import BlueOwnerReport from '@/pages/report/blue-owner-report' // 蓝主人业主报表
import BillStatement from '@/pages/report/bill-statement' // 结算账单报表
import MonthlySettleDetail from '@/pages/report/bill-statement/monthlySettleDetail' // 月度结算详情
import ManualRecord from '@/pages/report/bill-statement/manualRecord' // 月度结算详情
import ChainReport from '@/pages/report/chain-report' // 门店经营利润表
import ChainReportDetail from '@/pages/report/chain-report/chain-reportDetail' // 门店经营利润表

// 订单统计报表
export const orderReport = {
  path: 'report/orderReport',
  component: OrderReport
}

// 对账收款导入记录
export const importRecords = {
  path: 'report/importRecords',
  component: ImportRecords
}

// 丽家会物品更换报表
export const replaceReport = {
  path: 'report/replaceReport',
  component: ReplaceReport
}

// 业主营收报表
export const ownerRevenue = {
  path: 'report/ownerRevenue',
  component: OwnerRevenue
}

// PMS结算账单报表
export const pmsCheckRepor = {
  path: 'report/pmsCheckRepor',
  component: PmsCheckRepor
}

// 小程序推广报表
export const miniReport = {
  path: 'report/miniReport',
  component: MiniReport
}

// 蓝主人业主报表
export const blueOwnerReport = {
  path: 'report/BlueOwnerReport',
  component: BlueOwnerReport
}

// 结算账单报表
export const billStatement = {
  path: 'report/BillStatement',
  component: BillStatement
}

// 月度结算详情
export const monthlySettleDetail = {
  path: 'report/MonthlySettleDetail',
  component: MonthlySettleDetail
}

// 手工入账导入记录
export const manualRecord = {
  path: 'report/ManualRecord',
  component: ManualRecord
}

// 门店经营利润表
// 这个path是oms的配置信息
export const chainReport = {
  path: 'report/chainReport',
  component: ChainReport
}


// 门店经营利润表详情
// 这个path是oms的配置信息
export const chainReportDetail = {
  path: 'report/chainReportDetail',
  component: ChainReportDetail
}




// WEBPACK FOOTER //
// ./src/router/report.js